import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { COMUNICADOS, PAUTAS_REUNIOES } from '../../../app.constants';
import { AnexoReuniaoModel } from '../../shared/models/anexo-reuniao.model';
import { ComunicacaoModel } from '../../shared/models/comunicado.model';
import { ReuniaoModel } from '../../shared/models/reuniao.model';
import { TipoReuniaoModel } from '../../shared/models/tipo-reuniao.model';
declare var $: any;


@Injectable()
export class AdministrativoService {

  constructor(private httpClient: HttpClient) { }


  getTipoReuniao(tpReuniao: number) {
    return this.httpClient
      .get<TipoReuniaoModel>(`${PAUTAS_REUNIOES}/tipoReuniao/${tpReuniao}`)
      .toPromise();
  }

  getReunioesByTipoESituacao(tpReuniao: number, stReuniao: number, linesPerPage: number, page: number) {
    return this.httpClient
      .get<ReuniaoModel[]>(`${PAUTAS_REUNIOES}/reunioesByTipoESituacao/${tpReuniao}/${stReuniao}?linesPerPage=${linesPerPage}&page=${page}`)
      .toPromise();
  }

  getAnexoByReuniao(tpReuniao: number, stReuniao: string) {
    return this.httpClient
      .get<AnexoReuniaoModel[]>(`${PAUTAS_REUNIOES}/anexoReuniao/${tpReuniao}/${stReuniao}`)
      .toPromise();
  }


  getAnexo(tpReuniao: number, stReuniao: string, sqAnexo: string) {
    return this.httpClient
      .get<AnexoReuniaoModel>(`${PAUTAS_REUNIOES}/anexo/${tpReuniao}/${stReuniao}/${sqAnexo}`)
      .toPromise();
  }

  getQtdReunioesAssociadas(cdCentrus: number) {
    return this.httpClient
      .get<number>(`${PAUTAS_REUNIOES}/qtdReunioesAssociadas/${cdCentrus}`)
      .toPromise();
  }

  getPossuiAcessoAsPautasDaReuniao(cdCentrus: number, tpReuniao: string) {
    return this.httpClient
      .get<number>(`${PAUTAS_REUNIOES}/possuiAcessoAsPautasDaReuniao/${tpReuniao}/${cdCentrus}?${tpReuniao}`)
      .toPromise();
  }


  downloadDocumento(tpReuniao: number, stReuniao: string, sqAnexo: string) {
    return this.httpClient.get(`${PAUTAS_REUNIOES}/download/${tpReuniao}/${stReuniao}/${sqAnexo}`,  {
      responseType: 'blob' as 'json'
    })
    .toPromise();
  }

  handleFile(res: any, fileName: string) {


    const file = new Blob([res], {type: 'application/pdf'});

    // IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(file);
      return;
    }
    const fileURL = URL.createObjectURL(file);

    window.open(fileURL);
    // const blob = window.URL.createObjectURL(file);

    // const link = document.createElement('a');
    // link.href = blob;
    // link.download = fileName;

    // // link.click();
    // link.dispatchEvent(new MouseEvent('click', {
    //   bubbles: true,
    //   cancelable: true,
    //   view: window
    // }));

    // setTimeout(() => { // firefox
    //   window.URL.revokeObjectURL(blob);
    //   link.remove();
    // }, 100);
  }


  ////////// ENPOINTS DE MANUTENCAO DE COMUNICADOS

  getVerificarComun(tpComunicados: number, sqComunicados: number, anoSq: number) {
    return this.httpClient
      .get<Boolean>(`${COMUNICADOS}/verificarComu/${tpComunicados}/${sqComunicados}/${anoSq}`)
      .toPromise();
  }

  getObtermanutcomun(tpComunicados: number, sqComunicados: number, anoSq: number) {
    return this.httpClient
      .get<ComunicacaoModel>(`${COMUNICADOS}/obtermanutcomun/${tpComunicados}/${sqComunicados}/${anoSq}`)
      .toPromise();
  }

  insertComunicado(comunicacaoModel: ComunicacaoModel) {
    return this.httpClient
    .post(`${COMUNICADOS}/inserir`, comunicacaoModel)
    .toPromise();
  }

  updateComunicado(comunicacaoModel: ComunicacaoModel) {
    return this.httpClient
    .put(`${COMUNICADOS}/update/${comunicacaoModel.tpComunicados}/${comunicacaoModel.sqComunicados}/${comunicacaoModel.anoSq}`, comunicacaoModel)
    .toPromise();
  }

  deleteComunicado(comunicacaoModel: ComunicacaoModel) {
    return this.httpClient
    .delete(`${COMUNICADOS}/delete/${comunicacaoModel.tpComunicados}/${comunicacaoModel.sqComunicados}/${comunicacaoModel.anoSq}`)
    .toPromise();
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/administrativo/service/administrativo.service.ts